import React, { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import Link from 'next/link'

import sortBy from 'lodash/sortBy'
import partition from 'lodash/partition'

import { useStore } from 'hooks'
import { AuthorsStore } from 'stores/authors'
import { THEME } from 'utils'

const AuthorsIndex = () => {
  const authorsStore = useStore(AuthorsStore)
  const sortedAuthors = useMemo(() => {
    const authors = authorsStore.items
    const [suggestedAuthors, otherAuthors] = partition(authors, 'is_suggested')
    const sortedSuggested = sortBy(suggestedAuthors, '-sort')
    const sortedOthers = sortBy(otherAuthors, 'name')
    return [...sortedSuggested, ...sortedOthers]
  }, [authorsStore.items])

  return (
    <>
      <div className='container'>
        <div className='row row--main'>
          <div className='col col--main'>
            <div className='authorsContainer'>
              {sortedAuthors.map((author) => {
                const slug = author.author_url.split('/').pop()
                return (
                  <div className='tile' key={author.name}>
                    <Link href='/bio/[id]/[slug]' as={`/bio/${author.id}/${slug}`}>
                      <a>
                        <div className='authorName'>{author.name}</div>
                        <img src={author.headshot || '/static/images/headshot-placeholder.png'} alt={author.name} />
                      </a>
                    </Link>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .title {
          font-size: 48px;
          font-family: ${THEME.FONTS.BEBAS};
          text-transform: uppercase;
          padding-left: 12px;
        }
        .authorsContainer {
          display: grid;
          grid-template-columns: 1fr;
          grid-template-rows: auto;
        }
        .tile {
          padding: 12px;
          position: relative;
        }
        .tile img {
          cursor: pointer;
          width: 100%;
          max-width: 100%;
          background-color: #ffffff;
          box-shadow: ${THEME.BOX_SHADOW.DEFAULT};
        }
        @media (max-width: ${THEME.BREAKPOINTS.SM - 1}px) {
          .authorsContainer {
            margin-top: 8px;
          }
          .tile {
            padding: 6px;
          }
        }
        .authorName {
          position: absolute;
          top: 50%;
          left: 30px;
          transform: translate(0, -50%);
          width: 110px;
          color: #000000;
          font-family: ${THEME.FONTS.BEBAS};
          font-size: 30px;
          text-transform: uppercase;
        }
        @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
          .authorsContainer {
            grid-template-columns: 1fr 1fr;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.LG}px) {
          .authorsContainer {
            grid-template-columns: 1fr 1fr 1fr;
          }
        }
      `}</style>
    </>
  )
}

export default observer(AuthorsIndex)
